import { useEffect, FunctionComponent, JSXElementConstructor } from 'react'

import produce from 'immer'
import { notifyRender } from 'front-end-core/services/WindowService'

import { updateBreakpoints } from 'services/AccordionService'
import ResponseConsumer from 'components/shared/ResponseConsumer'
import Xml from 'components/shared/Xml'
import ContentItemContainer from 'redux/containers/components/accordion/ContentItemContainer'
import useBaseState from 'hooks/useBaseState'
import { ContentContainerProps } from 'redux/containers/components/accordion/ContentComponentContainer'
import { AdminButtonProps } from 'components/legislation/admin/AdminButton'

const ContentComponent:FunctionComponent<ContentComponentProps> = (props) => {
  const {
    path,
    originalNode,
    content = '',
    subscribedContent,
    depth,
    title,
    eventCategory,
    editMode,
    ContentEditor,
    AdminButton,
    flavour,
    id
  } = props

  const { baseState, setBaseState } = useBaseState(props.state, { expanded: 0, enableHighlight: 1, editing: 0 })
  const editing = baseState.editing > 0

  useEffect(() => {
    updateBreakpoints()
    notifyRender(id)
  }, [])

  const toggleEditing = ():void => setBaseState(prevState => produce(prevState, draft => {
    draft.editing = draft.editing ? 0 : 1
  }))

  const renderContent = (): JSX.Element => {
    const [sectionId] = path
    if (editing && editMode) {
      const ContentEditorComponent = ContentEditor as unknown as JSXElementConstructor<any>; // FIX ME ContentEditor is mapped to a boolean value
      return (
        <ContentEditorComponent
          node={originalNode}
          onDiscard={toggleEditing}
        />
      )
    }

    if (!content && subscribedContent) {
      return (
        <ResponseConsumer
          response={subscribedContent}
          content={() => (
            <Xml
              component='div'
              className='content-text'
              render={subscribedContent}
              sectionId={sectionId}
            />
          )}
        />
      )
    }
    // why has this gotten so complicated...
    const xmlContentMarginStyle = (depth: number, eventTypeCategory: string):{marginLeft: string} => {
      let marginLeft
      if (!title && eventTypeCategory !== 'Legislation') {
        marginLeft = `${((depth >= 3 ? depth : 3) - 3)}.8rem`
      } else if (eventTypeCategory !== 'Q&A') {
        marginLeft = `${depth}.75rem`
      } else {
        marginLeft = `${depth + 2}.75rem`
      }
      return ({ marginLeft })
    }

    return (
      <div className='content'>
        <Xml
          component='div'
          styles={{ ...xmlContentMarginStyle(depth, eventCategory), fontSize: '1rem' }}
          className='mr9 mr2-m content-text'
          render={content}
          sectionId={sectionId}
        />
      </div>
    )
  }

  const Admin = (): JSX.Element => {
    const AdminButtonComponent = AdminButton as unknown as JSXElementConstructor<AdminButtonProps>; // FIX ME AdminButton is mapped to a boolean value
    return (editMode && !editing && (
      <span className='group-content__admin-button'>
        <AdminButtonComponent
          url={null}
          editMode={false}
          onClick={toggleEditing}
        />
      </span>
    )) ||
    null
  }

  return (
    <ContentItemContainer state={baseState} {...{ props, flavour, renderContent }}>
      <Admin />
    </ContentItemContainer>
  )
}

interface ContentComponentProps extends ContentContainerProps{
  path: string[];
  id: string;
  content?: string;
  depth: number;
  title: string;
  eventCategory?: string;
  subscribedContent?: string;
  originalNode?: string;
  state?: any;
}

export default ContentComponent
